/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ApiRouteFormatter, getApiKey, isCloudRunEnabled } from "../ApiWeb";

let _rootDiv: HTMLDivElement | undefined = undefined;
let _iframeParentDiv: HTMLDivElement | undefined = undefined;
let _postMessageListener: (this: Window, ev: MessageEvent<any>) => any = undefined;
let _onPostMessage: Function | undefined = undefined;

export namespace UIViewer {
    export function Bind(accessToken: string, workspaceId: string, params: { modelId?: string, versionIds?: string[], quantityId?: string }, onPostMessage? : Function|undefined ): void {
        _rootDiv = _InitializeUI(accessToken, workspaceId, params);
        _onPostMessage = onPostMessage;
        document.body.appendChild(_rootDiv);
    }

    export function Unbind() {
        if (_rootDiv) {
            _rootDiv.remove();
        }

        if( _postMessageListener )
        {
            window.removeEventListener( "message", _postMessageListener, false );
        }
    }

    function _InitializeUI(accessToken: string, workspaceId: string, params: { modelId?: string, versionIds?: string[], quantityId?: string }): HTMLDivElement {
        let rootDiv = document.createElement("div");
        rootDiv.id = "ui-viewer-root-div";

        let titleELement = document.createElement("h2");
        titleELement.innerText = "Viewer";
        rootDiv.appendChild(titleELement);

        let brElement = document.createElement("br");
        rootDiv.appendChild(brElement);

        _iframeParentDiv = document.createElement("div");
        _iframeParentDiv.id = "ui-viewer-iframe-parent-div";
        rootDiv.appendChild(_iframeParentDiv);

        _iframeParentDiv.textContent = "";

        let iframeUrl: string = `${ApiRouteFormatter.FormatViewerUrl(isCloudRunEnabled())}`;
        iframeUrl += `&accessToken=${accessToken}`;
        iframeUrl += `&workspace=${workspaceId}`;

        let apiKey : string = getApiKey();
        if (apiKey) {
            iframeUrl += `&apiKey=${apiKey}`;
        }

        if( params?.modelId && params?.versionIds )
        {
            iframeUrl += `&model=${params.modelId}`;
            iframeUrl += `&versions=${params.versionIds}`;
        }
        else if( params?.quantityId )
        {
            iframeUrl += `&quantity=${params.quantityId}`;
        }
        else 
        {
            throw new Error( "[ui-viewer.ts] Invalid/Missing model & versions or quantity ids");
        }

        let iframe: HTMLIFrameElement = document.createElement("iframe");
        iframe.src = iframeUrl;
        iframe.width = "1024px";
        iframe.height = "768px";

        _iframeParentDiv.appendChild(iframe);

        //
        // --- Post Message Listener 

        _postMessageListener = function( e: any )
        {
            const viewerUrl : string = `${ApiRouteFormatter.FormatViewerUrl(isCloudRunEnabled())}`;;
            if ( !viewerUrl.startsWith( e.origin ) ) { 
                console.warn( `Message received from unknown origin: ${e.origin}`)
                return;
            }

            const dataAsStr : string = e.data;
            console.log("Message received from the viewer: " + e.data);
            
            const data : any = JSON.parse( dataAsStr );
            if( _onPostMessage )
            {
                _onPostMessage( data );
            }
        }
        window.addEventListener( "message", _postMessageListener, false );

        return rootDiv;
    }
}
